import { Component } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';

@Component({
  selector: 'app-active-checkbox-cell-renderer',
  template: `
    <mat-checkbox
      [checked]="params.value"
      (change)="onCheckboxChange($event)"
      class="ag-checkbox"
      color="primary">
    </mat-checkbox>
  `,
  styles: [`
    :host ::ng-deep .ag-checkbox {
      margin-left: 8px;
    }
  `]
})
export class ActiveCheckboxCellRendererComponent implements ICellRendererAngularComp {
  params: any;

  agInit(params: any): void {
    this.params = params;
  }

  refresh(params: any): boolean {
    this.params = params;
    return true;
  }

  onCheckboxChange(event: any): void {
  const newValue = event.checked;

  // Update the data value
  this.params.node.setDataValue('isActive', newValue);

  const isModified = this.params.data.originalActive !== newValue;
  const modifiedRows = this.params.context.modifiedRows;

  const index = modifiedRows.indexOf(this.params.data);

  if (isModified && index === -1) {
    modifiedRows.push(this.params.data);
  } else if (!isModified && index !== -1) {
    modifiedRows.splice(index, 1);
  }

  // // 🔥 Dispatch cellValueChanged event manually
  // this.params.api.dispatchEvent({
  //   type: 'cellValueChanged',
  //   data: this.params.data,
  //   column: this.params.column,
  //   value: newValue
  // });

  // Trigger button state update
  if (this.params.context.setButtonStates) {
    this.params.context.setButtonStates();
  }
}

}
